/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_team_selector_select_constructor = /** @type {(inputs: { number: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Select Constructor ${i?.number}`)
};

const es_f1_team_selector_select_constructor = /** @type {(inputs: { number: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Seleccionar Constructor ${i?.number}`)
};

const de_f1_team_selector_select_constructor = /** @type {(inputs: { number: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Konstrukteur ${i?.number} wählen`)
};

const nl_f1_team_selector_select_constructor = /** @type {(inputs: { number: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Selecteer constructeur ${i?.number}`)
};

const fr_f1_team_selector_select_constructor = /** @type {(inputs: { number: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sélectionner Constructeur ${i?.number}`)
};

const it_f1_team_selector_select_constructor = /** @type {(inputs: { number: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Seleziona Costruttore ${i?.number}`)
};

const pt_br2_f1_team_selector_select_constructor = /** @type {(inputs: { number: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Selecionar Construtor ${i?.number}`)
};

const pt_f1_team_selector_select_constructor = /** @type {(inputs: { number: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Selecionar Construtor ${i?.number}`)
};

const ja_f1_team_selector_select_constructor = /** @type {(inputs: { number: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`コンストラクター ${i?.number} を選択`)
};

const zh_f1_team_selector_select_constructor = /** @type {(inputs: { number: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`选择车队${i?.number}`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ number: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_team_selector_select_constructor = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_team_selector_select_constructor(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_team_selector_select_constructor", locale)
	if (locale === "en") return en_f1_team_selector_select_constructor(inputs)
	if (locale === "es") return es_f1_team_selector_select_constructor(inputs)
	if (locale === "de") return de_f1_team_selector_select_constructor(inputs)
	if (locale === "nl") return nl_f1_team_selector_select_constructor(inputs)
	if (locale === "fr") return fr_f1_team_selector_select_constructor(inputs)
	if (locale === "it") return it_f1_team_selector_select_constructor(inputs)
	if (locale === "pt-BR") return pt_br2_f1_team_selector_select_constructor(inputs)
	if (locale === "pt") return pt_f1_team_selector_select_constructor(inputs)
	if (locale === "ja") return ja_f1_team_selector_select_constructor(inputs)
	return zh_f1_team_selector_select_constructor(inputs)
};